import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { MaybeIconPropsAll } from 'common/icon/icon.js';

export type IForecastListItemProps = MaybeIconPropsAll & {
  title?: string;
  classes?: string;
};

export const ForecastListHeader = ({ title, classes, ...icon }: IForecastListItemProps) => {
  if ('icon' in icon) {
    return (
      <IconWithText {...icon} classes={classNames('IconWithText--vCenter IconWithText--small', classes)}>
        <p className="u-mT-0 u-mB-0 u-flex u-flexJustifyBetween u-flexAlignItemsCenter">
          <span className="grid-list-text u-flexGrow-0 u-textBold u-text-xs u-textUppercase">{title}</span>
        </p>
      </IconWithText>
    );
  }
  return (
    <p className="u-mT-0 u-mB-0 u-flex u-flexJustifyBetween u-flexAlignItemsCenter">
      <span className="grid-list-text u-flexGrow-0 u-textBold u-text-xs u-textUppercase">{title}</span>
    </p>
  );
};
